'use client'

import { cn } from '@/lib/utils'
import { ReactNode, useEffect, useRef, useState } from 'react'

const HEADER_GAP = 36

/**
 * Cột thông tin sản phẩm bên phải (desktop) dính bên dưới Header khi cuộn gallery.
 */
export const ProductInfoSticky = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const [top, setTop] = useState<number>(104)

  useEffect(() => {
    const update = () => {
      const header = document.querySelector('header')
      const headerBottom = Math.max(
        header?.getBoundingClientRect().bottom ?? 0,
        0
      )
      setTop(headerBottom + HEADER_GAP)
    }

    update()
    window.addEventListener('resize', update)
    window.addEventListener('scroll', update, { passive: true })
    return () => {
      window.removeEventListener('resize', update)
      window.removeEventListener('scroll', update)
    }
  }, [])

  return (
    <div
      ref={ref}
      className={cn('lg:sticky lg:self-start', className)}
      style={{ top }}
    >
      {children}
    </div>
  )
}
